// extracted by mini-css-extract-plugin
module.exports = {"button":"ShowMoreButton_button__xTchc","title":"ShowMoreButton_title__oQuGy"};